import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
var defaultValue = undefined;
var DialogContentWidthContext = /*#__PURE__*/React.createContext(defaultValue);
DialogContentWidthContext.displayName = 'DialogContentWidthContext';
export var Consumer = DialogContentWidthContext.Consumer;
export var Provider = DialogContentWidthContext.Provider;
export var withDialogContentWidth = Target => props => /*#__PURE__*/React.createElement(DialogContentWidthContext.Consumer, null, value => /*#__PURE__*/React.createElement(Target, _extends({}, props, {
  dialogContentWidth: value
})));
export var useDialogContentWidthContext = () => React.useContext(DialogContentWidthContext);
//# sourceMappingURL=index.js.map